<template>
    <!-- Confirm Password -->
    <div class="row">
        <div class="col-sm-12 mb-3" v-if="header">
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-envelope-at"></i>
                <h3 class="fw-semi-bold m-0">Your Email Address</h3>
            </div>
        </div>

        <div ref="viewEmailSection" class="col-12">
            <div class="d-flex align-items-center justify-content-between rounded-pill border py-2 px-3 input-container border-active-darken mb-3 border-secondary bg-light">
	            <label for="email">
		            <i class="me-3 dd-icon bi bi-envelope-at"></i>
	            </label>
	            <input v-model="email" readonly disabled autofocus type="email" ref="emailView" name="email" class="form-control m-0 border-0 fs-5 p-0 lh-fixed bg-light" :placeholder="getUser.email" >
	            <label for="email">
		            <i class="me-3 dd-icon bi bi-copy" v-tooltip="'Copy Email'" @click="helper.copyText(email)"></i>
	            </label>
            </div>

            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="close">Close</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, watch, ref, onMounted } from "vue";
import apiClient from "@/utils/axios.js";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import {useHttpErrorManager} from "@/composables/useHttpErrorManager.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";

const props = defineProps({
	header: { type: Boolean, required: false, default: true },
	autoSubmit: { type: Boolean, required: false, default: false }
});

const emits = defineEmits(['closeViewEmail']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const viewEmailSection = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

onMounted(async () => {
	await fetchEmail();
})

const getUser = computed(() => {
	return user.value;
});

const email = ref(getUser.email);

const fetchEmail = async () => {

    helper.loaderOn(viewEmailSection.value);

    try {
        const response = await apiClient.post('auth/user/fetchEmail', {});

        if (response.status >= 200 && response.status < 300) {
			email.value = response.data.email;
        }
	    helper.loaderOff(viewEmailSection.value);
    }
    catch (error) {
        helper.loaderOff(viewEmailSection.value);
        await useHttpErrorManager().handleError(error, true);
    }
}

const close = async () => {
	emits('closeViewEmail');
}

defineExpose({
    close
});
</script>
